import { makeVar } from '@apollo/client'
import { ColumnHeaderMenuState } from 'components/AgGrid/types'

export const isProductsDetailsColumnHeaderRightClickMenuVar = makeVar<
  ColumnHeaderMenuState | false
>(false)
